<template>
  <ul class="details-data-list-parts">
    <li v-for="(v, i) in detailsListItems" :key="i" class="details-data-list-parts__list">
      <a v-if="v.link" :href="v.link" target="_blank" class="details-data-list-parts__item">
        <span class="details-data-list-parts__label" v-html="v.name" />
        <img
          class="details-data-list-parts__icon"
          :src="require('@/assets/img/icon/icon_external_link_outline.svg')"
          alt=""
        />
      </a>
      <div v-else class="details-data-list-parts__item details-data-list-parts__item--has-text">
        <span class="details-data-list-parts__label" v-html="v.name" />
        <span class="details-data-list-parts__data">{{ v.text }}</span>
      </div>
    </li>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * マイページ: 詳細設定 データリスト パーツ
 */
export default defineComponent({
  name: 'DetailsDataListParts',
  props: {
    /**
     * データリスト
     */
    detailsListItems: {
      type: Array,
      required: true,
    },
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.details-data-list-parts {
  width: 100%;
  margin-bottom: 24px;
  background: $white;

  &__list {
    &:last-child .details-data-list-parts__item {
      padding-bottom: 17px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
  }

  &__item {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 17px 16px 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    color: $black80;
    font-weight: 700;

    &--has-text {
      .details-data-list-parts__label {
        width: calc(100% - 114px);
      }
    }
  }

  &__label {
    width: calc(100% - 40px);
    text-align: left;
  }

  &__text {
    width: 108px;
    text-align: right;
    font-size: 13px;
  }
}

@media screen and (min-width: $responsiveMypageMaxWidth) {
  .details-data-list-parts {
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>
